import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import { Header } from "../Header/header";
import AssetManagement from "./Asset Management/AssetManagement";
import AssetDashboard from "./Asset Dashboard/AssetDashboard";
import { Footer } from "../Footer/footer";
import Trustees from "./Trustees/Trustees";
import { DataProvider } from "../../Context/DataContext";
import Tree from "./Inheritance Tree/tree";
import InheritanceParameters from "./Inheritance Parameters/InheritanceParameters";
import Dashboard from "./Dashboard/Dashboard";
import { MyAccount } from "./My Account/MyAccount";
// import OnBoardingDashboard from './OnBoarding/OnBoardingDashboard'
// import { OnBoardingHeader } from './OnBoarding/OnBoardingheader'
// import { OnBoardProvider } from '../../Context/OnboardingContext'
// import TreeOnboarding from './OnBoarding/treeOnboarding'
import { RequireOTP } from "../../Utils/RequireOTP";
import { RequireAuth } from "../../Utils/RequireAuth";
import { FSessionTimeout, KeepSessionAlive } from "../SessionTimeout";
import { AuthProvider } from "../../Context/AuthContext";
import React from "react";
import { ChoosePlan } from "./My Account/ChoosePlan";
import { PaymentSuccessPage } from "./My Account/PaymentSuccessPage";
import { Newsletter } from "./Newsletter/Newsletter";
import ChangeSelfPwd from "./Self Recovery/ChangeSelfPassword";
import { Login } from "../Login/Login";
import { OTP } from "../Login/OTP";
import { LoginRecoveryKey } from "../Login/LoginRecoveryKey";
import { LoginSelfRecovery } from "../Login/LoginSelfRecovery";
import { HelpCenter } from "../Pages/HelpCenter/HelpCenter";
import { EstatePlanning } from "../Pages/EstatePlanning/EstatePlanning";
import { ContactUs } from "../Pages/ContactUs/ContactUs";
import { BeneficiaryConditions } from "../Beneficiary/BeneficiaryConditions";
import Beneficiaries from "./Beneficiaries/Beneficiaries";
import { NotFound } from "../Not Found/NotFound";
import { useEffect } from "react";
import Privacy from "../Terms/Privacy";
import PrivacyFrench from "../Terms/PrivacyFrench";
import PrivacyEnglish from "../Terms/PrivacyEnglish";
import TermsFrench from "../Terms/TermsFrench";
import Terms from "../Terms/Terms";
import TermsEnglish from "../Terms/TermsEnglish";
import { LoginRedirection } from "../Login/LoginRedirection";
import PrepareUser from "../Partner/PrepareUser";
import MyCustomers from "./My Customers/MyCustomers";
import CustomerDetail from "./My Customers/CustomerDetail";
/*
  The band's links for a signed-in customer. This is the list that is used --
  header.jsx carries one of its own, but only as a fallback for the callers
  that pass none, and every route below passes this.
*/
const headerElements = [
  { text: "Dashboard", link: "/user/dashboard" },
  { text: "Asset Management", link: "/user/assetmanagement" },
  /*
    The Wealth Report view of Asset Management, which is where its crumb
    leads too -- the crumb sits under the page title in grey on white and was
    being missed, so this is the entry that says the page exists before you
    are already standing on its neighbour.

    Nested under Asset Management on purpose: the underline follows the
    LONGEST matching link (see linkDepth in header.jsx), so this lights on
    its own page and leaves the parent lit everywhere else beneath it.

    One entry serves both headers: the desktop band and the burger menu are
    built from this same list.
  */
  { text: "Wealth Report", link: "/user/assetmanagement/dashboard" },
  { text: "Beneficiaries", link: "/user/beneficiaries" },
  { text: "Trusted Advisors", link: "/user/advisors" },
  { text: "My Account", link: "/user/account" },
];

export function UserRoutes() {
  // const headerElements=[{"text":"Dashboard", "link":"/user/dashboard"},{"text":"Assets", "link":"/user/assets"},{"text":"Beneficiaries", "link":"/user/beneficiaries"},{"text":"Trusted Advisors", "link":"/user/advisors"},{"text":"Inheritance Parameters", "link":"/user/parameters"},{"text":"My Account", "link":"/user/account"}]
  return (
    <AuthProvider>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header elements={[]} />
              <Login />
              <Footer />
            </>
          }
        ></Route>
        <Route
          path="/login/OTP"
          element={
            <RequireAuth>
              <Header elements={[]} />
              <OTP />
              <Footer />
            </RequireAuth>
          }
        ></Route>
        <Route
          path="/login/recoverykey"
          element={
            <>
              <FSessionTimeout onIdlePath="/login/recoverykey" />
              <Header elements={[]} />
              <LoginRecoveryKey />
              <Footer />
            </>
          }
        ></Route>
        <Route
          path="/login/selfrecovery"
          element={
            <>
              <FSessionTimeout onIdlePath="/login/selfrecovery" />
              <Header elements={[]} />
              <LoginSelfRecovery />
              <Footer />
            </>
          }
        ></Route>
        {/*
          The Assets tab was retired and Asset Management took its place. The
          route stays as a redirect rather than being deleted, so bookmarks and
          links already sent out still land somewhere sensible. Nothing is lost
          with the page: the Inheritance Tree it used to carry also renders on
          /user/dashboard, and assets are created from Asset Management's own
          add button.
        */}
        <Route
          path="/user/assets"
          element={<Navigate to="/user/assetmanagement" replace />}
        ></Route>
        <Route
          path="/user/assetmanagement"
          element={
            <RequireOTP>
              <FSessionTimeout />

              <DataProvider>
                <div style={{ position: "relative" }}>
                  <Header elements={headerElements} />
                </div>
                {/*
                  No 1280px cap here, unlike every other page. The asset table
                  is the one screen that gets wider rather than emptier as the
                  monitor does — see `.page_wide`, which keeps the design's
                  gutter as a share of the width instead of a fixed 16px.
                */}
                <AssetManagement />
                <Footer />
              </DataProvider>
            </RequireOTP>
          }
        ></Route>
        <Route
          path="/user/beneficiaries"
          element={
            <RequireOTP>
              <FSessionTimeout />
              <DataProvider>
                <Header elements={headerElements} />
                <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                  <Beneficiaries />
                  <Tree />
                </div>
                <Footer />
              </DataProvider>
            </RequireOTP>
          }
        ></Route>
        <Route
          path="/user/parameters"
          element={
            <RequireOTP>
              <FSessionTimeout />
              <DataProvider>
                <Header elements={headerElements} />
                <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                  <InheritanceParameters />
                </div>
                <Footer />
              </DataProvider>
            </RequireOTP>
          }
        ></Route>
        <Route
          path="/user/changepwd"
          element={
            <RequireOTP>
              <FSessionTimeout />
              <DataProvider>
                <Header
                  selfrecovery={true}
                  elements={[{ text: "", link: "" }]}
                />
                <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                  <ChangeSelfPwd />
                </div>
                <Footer />
              </DataProvider>
            </RequireOTP>
          }
        ></Route>
        <Route
          path="/user/advisors"
          element={
            <RequireOTP>
              <FSessionTimeout />
              <DataProvider>
                <Header elements={headerElements} />
                <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                  <Trustees />
                  <Tree />
                </div>
                <Footer />
              </DataProvider>
            </RequireOTP>
          }
        ></Route>
        <Route
          path="/user/dashboard"
          element={
            <RequireOTP>
              <FSessionTimeout />

              <DataProvider>
                <Header elements={headerElements} />
                <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                  <Dashboard />
                  <Tree />
                </div>
                <Footer />
              </DataProvider>
            </RequireOTP>
          }
        ></Route>
        <Route
          path="/user/account"
          element={
            <RequireOTP>
              <FSessionTimeout />
              <DataProvider>
                <Header elements={headerElements} />
                <MyAccount />
                <Footer />
              </DataProvider>
            </RequireOTP>
          }
        ></Route>
        {/*
          The partner's customer list. It brings its own title and, per the
          design, no tab strip -- see CUSTOMERS_PATH in PartnerNav.
        */}
        <Route
          path="/user/customers"
          element={
            <RequireOTP>
              <FSessionTimeout />
              <DataProvider>
                <Header elements={headerElements} />
                <MyCustomers />
                <Footer />
              </DataProvider>
            </RequireOTP>
          }
        ></Route>
        {/*
          One customer's profile. The tab is part of the path so a profile can be
          linked to and survives a reload; no tab means the dashboard.
        */}
        {["/user/customers/:id", "/user/customers/:id/:tab"].map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <RequireOTP>
                <FSessionTimeout />
                <DataProvider>
                  <Header elements={headerElements} />
                  <CustomerDetail />
                  <Footer />
                </DataProvider>
              </RequireOTP>
            }
          ></Route>
        ))}
        <Route
          path="/user/plan"
          element={
            <RequireOTP>
              <FSessionTimeout />

              <DataProvider>
                <Header elements={headerElements} />
                <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
                  <ChoosePlan />
                </div>
                <Footer />
              </DataProvider>
            </RequireOTP>
          }
        ></Route>
      </Routes>
    </AuthProvider>
  );
}
export const UserRoutesv1 = [
  <Route
    path="/login"
    element={
      <>
        <Header elements={[]} />
        <Login />
        <Footer />
      </>
    }
  ></Route>,
  <Route
    path="/login/redirect/:redirect_id"
    element={
      <>
        <Header elements={[]} />
        <LoginRedirection />
        <Footer />
      </>
    }
  ></Route>,
  <Route
    path="/login/OTP"
    element={
      <RequireAuth>
        <Header elements={[]} />
        <OTP />
        <Footer />
      </RequireAuth>
    }
  ></Route>,
  <Route
    path="/login/recoverykey"
    element={
      <>
        <FSessionTimeout onIdlePath="/login/recoverykey" />
        <Header elements={[]} />
        <LoginRecoveryKey />
        <Footer />
      </>
    }
  ></Route>,
  <Route
    path="/login/selfrecovery"
    element={
      <>
        <FSessionTimeout onIdlePath="/login/selfrecovery" />
        <Header elements={[]} />
        <LoginSelfRecovery />
        <Footer />
      </>
    }
  ></Route>,
  <Route
    key="assets-redirect"
    path="/user/assets"
    element={<Navigate to="/user/assetmanagement" replace />}
  ></Route>,
  <Route
    key="asset-management"
    path="/user/assetmanagement"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <div style={{ position: "relative" }}>
            <Header elements={headerElements} />
          </div>
          {/* Uncapped; see the note on the other Asset Management route. */}
          <AssetManagement />
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  /*
    The Wealth Report, reached from Asset Management's "Dashboard" crumb. Under
    that path rather than beside /user/dashboard, which is the account's own
    dashboard and a different screen. Same shell as the page above it.
  */
  <Route
    key="asset-management-dashboard"
    path="/user/assetmanagement/dashboard"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <div style={{ position: "relative" }}>
            <Header elements={headerElements} />
          </div>
          <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
            <AssetDashboard />
          </div>
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  <Route
    path="/user/beneficiaries"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <Header elements={headerElements} />
          <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
            <Beneficiaries />
            <Tree />
          </div>
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  <Route
    path="/user/newsletter"
    element={
      <DataProvider>
        <Header elements={headerElements} />
        <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
          <Newsletter />
        </div>
        <Footer />
      </DataProvider>
    }
  ></Route>,
  <Route
    path="/user/parameters"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <Header elements={headerElements} />
          <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
            <InheritanceParameters />
          </div>
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  <Route
    path="/user/changepwd"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <Header selfrecovery={true} elements={[{ text: "", link: "" }]} />
          <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
            <ChangeSelfPwd />
          </div>
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  <Route
    path="/user/advisors"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <Header elements={headerElements} />
          <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
            <Trustees />
            <Tree />
          </div>
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  <Route
    path="/user/dashboard"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <Header elements={headerElements} />
          <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
            <Dashboard />
            <Tree />
          </div>
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  <Route
    path="/user/account"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <Header elements={headerElements} />
          <MyAccount />
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  <Route
    key="my-customers"
    path="/user/customers"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <Header elements={headerElements} />
          <MyCustomers />
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  <Route
    key="customer-detail"
    path="/user/customers/:id"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <Header elements={headerElements} />
          <CustomerDetail />
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  <Route
    key="customer-detail-tab"
    path="/user/customers/:id/:tab"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <Header elements={headerElements} />
          <CustomerDetail />
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  <Route
    path="/user/plan"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <Header elements={headerElements} />
          <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
            <ChoosePlan />
          </div>
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  <Route
    path="/user/success"
    element={
      <DataProvider>
        <Header elements={headerElements} showFreezed={false} />
        <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
          <PaymentSuccessPage />
        </div>
        <Footer />
      </DataProvider>
    }
  ></Route>,
  <Route
    path="/user/prepare"
    element={
      <>
      <DataProvider>
        <Header elements={headerElements} showFreezed={false} />
        <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
          <PrepareUser />
        </div>
        <Footer />
      </DataProvider>
      </>
    }
  ></Route>,
  <Route
    path="/user/help/center"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <Header elements={headerElements} />
          <HelpCenter />
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  <Route
    path="/user/estate/planning"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <Header elements={headerElements} />
          <EstatePlanning />
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  <Route
    path="/user/contact-us"
    element={
      <RequireOTP>
        <FSessionTimeout />
        <KeepSessionAlive />
        <DataProvider>
          <Header elements={headerElements} />
          <ContactUs />
          <Footer />
        </DataProvider>
      </RequireOTP>
    }
  ></Route>,
  <Route
    path="/user/terms-and-conditions"
    element={
      <>
        <Terms />
      </>
    }
  ></Route>,
  <Route
    path="/user/terms-and-conditions/en"
    element={
      <>
        <RequireOTP>
          <FSessionTimeout />
          <KeepSessionAlive />
          <DataProvider>
            <Header />
            <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
              <TermsEnglish />
            </div>
            <Footer />
          </DataProvider>
        </RequireOTP>
      </>
    }
  ></Route>,
  <Route
    path="/user/terms-and-conditions/fr"
    element={
      <>
        <RequireOTP>
          <FSessionTimeout />
          <KeepSessionAlive />
          <DataProvider>
            <Header />
            <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
              <TermsFrench />
            </div>
            <Footer />
          </DataProvider>
        </RequireOTP>
      </>
    }
  ></Route>,
  <Route
    path="/user/privacy-policy"
    element={
      <>
        <Privacy />
      </>
    }
  ></Route>,
  <Route
    path="/user/privacy-policy/fr"
    element={
      <>
        <RequireOTP>
          <FSessionTimeout />
          <KeepSessionAlive />
          <DataProvider>
            <Header />
            <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
              <PrivacyFrench />
            </div>
            <Footer />
          </DataProvider>
        </RequireOTP>
      </>
    }
  ></Route>,
  <Route
    path="/user/privacy-policy/en"
    element={
      <>
        <RequireOTP>
          <FSessionTimeout />
          <KeepSessionAlive />
          <DataProvider>
            <Header />
            <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
              <PrivacyEnglish />
            </div>
            <Footer />
          </DataProvider>
        </RequireOTP>
      </>
    }
  ></Route>,
  <Route
    path="/user/xy_xy"
    element={
      <>
        <RequireOTP>
          <div>{JSON.stringify(sessionStorage)}</div>
        </RequireOTP>
      </>
    }
  ></Route>,
];
